import { render, staticRenderFns } from "./AssetsDownload.vue?vue&type=template&id=59131183&scoped=true&"
import script from "./AssetsDownload.vue?vue&type=script&lang=ts&"
export * from "./AssetsDownload.vue?vue&type=script&lang=ts&"
import style0 from "./AssetsDownload.vue?vue&type=style&index=0&id=59131183&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59131183",
  null
  
)

export default component.exports